import {
	ForexAccountVerifying,
	ForexBuyContract,
	ForexBuyDraft,
	ForexBuyIdnSearchParams
} from "@/feature/Forex/api/form/forex-form.interface";
import { ForexStatus } from "@/feature/Forex/api/history/forex-history.interface";
import { ForexCurrency } from "@/feature/Forex/store/interface";
import { ForexOperationType } from "@/feature/Forex/api/forex.interface";

export const mapForexBuyCreatedDraft = (
	draft?: Partial<ForexBuyDraft>
): Required<ForexBuyDraft> => ({
	operationType: draft?.operationType || ForexOperationType.BUY,
	operDay: draft?.operDay || '',
	createdAt: draft?.createdAt || '',
	currency: draft?.currency || ForexCurrency.USD,
	requestAmount: draft?.requestAmount || 0,
	purpose: draft?.purpose || '',
	course: draft?.course || 0,
	amountUzs: draft?.amountUzs || 0,
	account: draft?.account || '',
	reservingAccount: draft?.reservingAccount || '',
	receiverAccount: draft?.receiverAccount || '',
	phoneNumber: draft?.phoneNumber || '',
	loanAccount: draft?.loanAccount || '',
	contractNumber: draft?.contractNumber || '',
	contractDate: draft?.contractDate || '',
	contractId: draft?.contractId || '',
	contractEndDate: draft?.contractEndDate || '',
	partnerName: draft?.partnerName || '',
	partnerCountry: draft?.partnerCountry || '',
	partnerCountryCode: draft?.partnerCountryCode || '',
	contractAmount: draft?.contractAmount || 0,
	serviceDescription: draft?.serviceDescription || '',
	otherServiceDetails: draft?.otherServiceDetails || '',
	otherPurposeDetails: draft?.otherPurposeDetails || '',
	isFundsTransferAllowed: draft?.isFundsTransferAllowed || false,
	fundsSource: draft?.fundsSource || '',
	mfo: draft?.mfo || '',
	currencyAccount: draft?.currencyAccount || '',
	fundsTransferAllowed: draft?.fundsTransferAllowed || false,
	foreignExchangeId: draft?.foreignExchangeId || 0,
	status: draft?.status || ForexStatus.DRAFT,
	fileAttachments: draft?.fileAttachments || [],
	fundSourceText: draft?.fundSourceText || '',
	hidden: undefined
});

export const mapForexDraftList = (drafts?: Partial<ForexBuyDraft>[]) =>
	(drafts || []).map(mapForexBuyCreatedDraft);

export const mapForexAccountVerifying = (
	response?: ForexAccountVerifying
): Required<ForexAccountVerifying> => ({
	status: response?.status || null,
	foreignExchangeId: response?.foreignExchangeId || 0,
	actualCourse: response?.actualCourse || 0,
	previousCourse: response?.previousCourse || 0,
	newAmountUzs: response?.newAmountUzs || 0,
	previousAmountUzs: response?.previousAmountUzs || 0,
	missingAmount: response?.missingAmount || 0,
});